import React, { useMemo, useState, useEffect } from 'react'
import ShellRootContext from './ShellRootContext'

import resources from '../../assets/locale'
import { findLocaleFallback } from '../../utils/find-locale-fallback'

const ShellRootProvider = ({ children, interfaces }) => {
  const [t, setT] = useState()

  const { v1 } = interfaces
  const { localization } = v1

  const TranslatorProvider = useMemo(
    () => localization.getReactTranslatorProvider(React),
    [localization]
  )

  // Create a translator function by providing the resource files
  useEffect(() => {
    const country = v1?.localization?.country || 'US'
    const language = v1?.localization?.language || 'en'
    const options = {
      fallbackLng: [findLocaleFallback(language, country)],
      ensureFallbackLng: true
    }
    v1.localization
      .createTranslatorFunction(resources, options)
      .then((v) => setT(() => v))
  }, [v1])

  const value = useMemo(() => ({ interfaces, t }), [interfaces, t])

  // Wait for the translator function creation to show the content
  if (!t) return null

  return (
    <ShellRootContext.Provider value={value}>
      <TranslatorProvider resources={localization.resources || resources}>
        {children}
      </TranslatorProvider>
    </ShellRootContext.Provider>
  )
}

export default ShellRootProvider
